import apiClient from "@/shared/api/apiClient";

export const getRoleList = async (params) => {
  try {
    const { data } = await apiClient.get("/roles/list/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getRoleList failed", e);
  }
};

export const getRoleItem = async (id) => {
  try {
    const { data } = await apiClient.get(`/roles/${id}/`);
    return data;
  } catch (e) {
    console.error("getRoleItem failed", e);
  }
};

export const createRole = async (params) => {
  const result = await apiClient.post(`/roles/`, {
    ...params,
  });
  return result.data;
};

export const updateRole = async (id, params) => {
  const { data } = await apiClient.put(`/roles/${id}`, {
    ...params,
  });
  return data;
};

export const removeRole = async (id) => {
  const { data } = await apiClient.delete(`/roles/${id}`);
  return data;
};
